import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { checkAlertCount } from "../../pages/alerts/alertsNeedingApproval/utils";
import { approveAlert } from "../../pages/alerts/alertsNeedingApproval/approveAlertSlice";
import { denyAlert } from "../../pages/alerts/alertsNeedingApproval/denyAlertSlice";
import { listApprovalAlert } from "../../pages/alerts/alertsNeedingApproval/listApprovalSlice";
import useNotification from "../notification/useNotification";
import { isSuccessResponse } from "../../common/utils";

const Modal4ApproveAllAlert=({data}:{data?:any})=> {
  //  TODO create custom hook to handle to state management
  const dispatch: any = useDispatch();
  const approveId: string[] = [];
  const denyId: string[] = [];
  data?.map((item) => {
    if (checkAlertCount(item)) {
      approveId.push(item._id);
    } else {
      denyId.push(item._id);
    }
  });
  const [show, setShow] = useState<boolean>(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const { showSuccessNotification, showWarningNotification } = useNotification();

  const dispatchApproveAlerts = (action, payload: string[]) => {
    try {
      dispatch(action(payload)).then((response) => {
      if(isSuccessResponse(response.payload)) {
        showSuccessNotification(response.payload.message);
        dispatch(listApprovalAlert());
      }
      else {
        showWarningNotification(response.payload.response.data.message);
      }
      });
    } catch (error) {
      console.error("Error:", error);
    }
  };

  const handleApproveAllClose = async () => {
    handleClose();
    try {
      const approvePromise =
        approveId.length > 0
          ? dispatchApproveAlerts(approveAlert, approveId)
          : Promise.resolve();
      const denyPromise =
        denyId.length > 0
          ? dispatchApproveAlerts(denyAlert, denyId)
          : Promise.resolve();
      await Promise.all([approvePromise, denyPromise]);
    } catch (error) {
      console.error("Error:", error);
    }
    setShow(false);
  };

  return (
    <>
      <Button onClick={handleShow} className="buttonLight">
        Approve All
      </Button>

      <Modal
        show={show}
        onHide={handleClose}
        className="modal-container modalDenyalerts"
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>
            <div className="delete-heading">
              <h1>Approve All Alerts</h1>
            </div>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <p>Are you sure you want to approve all alerts?</p>
          <p>
            {denyId.length > 0
              ? `(${denyId.length}) alerts will be denied because of endtime Expired`
              : ``}
          </p>
          <p>
            {approveId.length > 0
              ? `(${approveId.length}) alerts will be approved`
              : ``}
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn-cancel" onClick={handleClose}>
            Cancel
          </Button>
          <Button className="btn-style" onClick={handleApproveAllClose}>
            Approve All
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Modal4ApproveAllAlert;
